import './index.css'
import {Component} from 'react'
import DenominationItem from '../DenominationItem'

class CashWithdrawal extends Component {
  state = {money: 2000}

  cutAmount = amount => {
    this.setState(prev => {
      if (prev.money >= amount) {
        return {money: prev.money - amount}
      }
      return null
    })
  }

  render() {
    const {money} = this.state
    const {denominationsList} = this.props
    return (
      <div className="bg">
        <div className="card">
          <div className="user">
            <p className="s">N</p>
            <h1 className="name">Nikhil Kumar</h1>
          </div>

          <div className="balance">
            <p className="kk">Your Balance</p>
            <span>
              <p className="pp">{money}</p>
              <br />
              In Rupees
            </span>
          </div>

          <p className="w">Withdraw</p>
          <p className="c">CHOOSE SUM (IN RUPEES)</p>

          <ul className="list">
            {denominationsList.map(each => (
              <DenominationItem
                cutAmount={this.cutAmount}
                key={each.id}
                amount={each.value}
              />
            ))}
          </ul>
        </div>
      </div>
    )
  }
}
export default CashWithdrawal
